import { useState, useEffect } from 'react';
import { FaSave, FaPlus, FaTrash } from 'react-icons/fa';

const ChatbotSettings = ({ onSave }) => {
  const [enabled, setEnabled] = useState(true);
  const [welcomeMessage, setWelcomeMessage] = useState("Hello! How can I help you today?");
  const [apiKey, setApiKey] = useState("");
  const [aiEnabled, setAiEnabled] = useState(true);
  const [aiModel, setAiModel] = useState("claude-3-sonnet");
  const [temperature, setTemperature] = useState(0.7);
  const [maxTokens, setMaxTokens] = useState(1000);
  const [responses, setResponses] = useState([
    {
      id: 1,
      question: "What services do you offer?",
      answer: "I offer AI development, web development, and mechanical engineering services."
    },
    {
      id: 2,
      question: "How can I contact you?",
      answer: "You can reach me through the contact form on my website or via email at dhiraj@example.com."
    },
    {
      id: 3,
      question: "What is your experience?",
      answer: "I have extensive experience in AI engineering, web development, and mechanical innovations. I've worked on various projects including AI solutions, web applications, and mechanical designs."
    },
    {
      id: 4,
      question: "Do you offer freelance services?",
      answer: "Yes, I offer freelance services in AI development, web development, and mechanical engineering. Feel free to contact me to discuss your project requirements."
    },
    {
      id: 5,
      question: "What technologies do you work with?",
      answer: "I work with a wide range of technologies including AI/ML frameworks, web development stacks (React, Node.js), and mechanical engineering tools. I'm constantly learning and adapting to new technologies."
    }
  ]);

  useEffect(() => {
    const savedSettings = localStorage.getItem('chatbotSettings');
    if (savedSettings) {
      try {
        const settings = JSON.parse(savedSettings);
        setEnabled(settings.enabled);
        setWelcomeMessage(settings.welcomeMessage);
        setApiKey(settings.apiKey);
        setAiEnabled(settings.aiEnabled);
        setAiModel(settings.aiModel);
        setTemperature(settings.temperature);
        setMaxTokens(settings.maxTokens);
        if (settings.responses && settings.responses.length > 0) {
          setResponses(settings.responses);
        }
      } catch (error) {
        console.error('Error loading settings:', error);
      }
    }
  }, []);

  const addResponse = () => {
    setResponses([
      ...responses,
      {
        id: Date.now(),
        question: "",
        answer: ""
      }
    ]);
  };

  const removeResponse = (id) => {
    setResponses(responses.filter(r => r.id !== id));
  };

  const updateResponse = (id, field, value) => {
    setResponses(responses.map(r => 
      r.id === id ? { ...r, [field]: value } : r
    ));
  };

  const saveSettings = () => {
    const settings = {
      enabled,
      welcomeMessage,
      apiKey,
      aiEnabled,
      aiModel,
      temperature,
      maxTokens,
      responses: responses.filter(r => r.question.trim() && r.answer.trim()) // Only save non-empty responses
    };
    localStorage.setItem('chatbotSettings', JSON.stringify(settings));
    if (onSave) {
      onSave(settings);
    }
  };

  return (
    <div className="space-y-6">
      {/* Enable Chatbot */}
      <div className="flex items-center justify-between">
        <label className="text-white font-medium">Enable Chatbot</label>
        <label className="relative inline-flex items-center cursor-pointer">
          <input
            type="checkbox"
            checked={enabled}
            onChange={(e) => setEnabled(e.target.checked)}
            className="sr-only peer"
          />
          <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
        </label>
      </div>
      
      {/* Welcome Message */}
        <div>
        <label className="block text-white mb-2">Welcome Message</label>
        <input
          type="text"
          value={welcomeMessage}
          onChange={(e) => setWelcomeMessage(e.target.value)}
          className="w-full bg-gray-700 text-white rounded-md px-4 py-2"
          placeholder="Enter welcome message"
        />
        </div>
        
      {/* API Key */}
          <div>
        <label className="block text-white mb-2">Claude API Key</label>
            <input
              type="password"
          value={apiKey}
          onChange={(e) => setApiKey(e.target.value)}
          className="w-full bg-gray-700 text-white rounded-md px-4 py-2"
          placeholder="Enter your Claude API key"
        />
          </div>

      {/* AI Settings */}
      <div className="border-t border-gray-700 pt-4">
        <div className="flex items-center justify-between mb-4">
          <label className="text-white font-medium">Enable AI Responses</label>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              checked={aiEnabled}
              onChange={(e) => setAiEnabled(e.target.checked)}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-primary"></div>
          </label>
          </div>

        {aiEnabled && (
          <div className="space-y-4">
            <div>
              <label className="block text-white mb-2">AI Model</label>
              <select
                value={aiModel}
                onChange={(e) => setAiModel(e.target.value)}
                className="w-full bg-gray-700 text-white rounded-md px-4 py-2"
              >
                <option value="claude-3-opus">Claude 3 Opus</option>
                <option value="claude-3-sonnet">Claude 3 Sonnet</option>
                <option value="claude-3-haiku">Claude 3 Haiku</option>
              </select>
            </div>
        
        <div>
              <label className="block text-white mb-2">Temperature ({temperature})</label>
            <input
              type="range"
              min="0"
              max="1"
              step="0.1"
                value={temperature}
                onChange={(e) => setTemperature(parseFloat(e.target.value))}
              className="w-full"
            />
          </div>
          
          <div>
              <label className="block text-white mb-2">Max Tokens</label>
            <input
              type="number"
                value={maxTokens}
                onChange={(e) => setMaxTokens(parseInt(e.target.value))}
                className="w-full bg-gray-700 text-white rounded-md px-4 py-2"
                min="1"
                max="4096"
              />
            </div>
          </div>
        )}
      </div>
      
      {/* Manual Responses */}
      <div className="border-t border-gray-700 pt-4">
        <h3 className="text-white font-medium mb-4">Manual Responses</h3>
        <p className="text-gray-400 mb-4">These responses will be used when the AI is disabled or when a question matches these keywords.</p>
        <div className="space-y-4">
          {responses.map((response) => (
            <div key={response.id} className="bg-gray-700 p-4 rounded-lg">
              <div className="flex justify-between items-center mb-4">
                <h4 className="text-white">Response</h4>
                <button
                  onClick={() => removeResponse(response.id)}
                  className="text-red-400 hover:text-red-300"
                >
                  <FaTrash />
                </button>
        </div>
              <div className="space-y-4">
                <input
                  type="text"
                  value={response.question}
                  onChange={(e) => updateResponse(response.id, 'question', e.target.value)}
                  className="w-full bg-gray-700 text-white rounded-md px-4 py-2"
                  placeholder="Question or keyword"
                />
                <textarea
                  value={response.answer}
                  onChange={(e) => updateResponse(response.id, 'answer', e.target.value)}
                  className="w-full bg-gray-700 text-white rounded-md px-4 py-2"
                  rows={3}
                  placeholder="Answer"
                />
              </div>
            </div>
          ))}
          <button
            onClick={addResponse}
            className="btn btn-primary flex items-center gap-2"
          >
            <FaPlus /> Add Manual Response
          </button>
        </div>
      </div>
      
      {/* Save Button */}
      <div className="flex justify-end mt-8">
        <button
          onClick={saveSettings}
          className="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-lg flex items-center gap-2"
        >
          <FaSave /> Save Chatbot Settings
        </button>
      </div>
    </div>
  );
};

export default ChatbotSettings; 